var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 118,
    viewBox: "0 0 119 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4984 5.90039C30.2226 5.90039 6.39844 29.7246 6.39844 59.0004C6.39844 88.2762 30.2226 112.1 59.4984 112.1C88.7742 112.1 112.598 88.2762 112.598 59.0004C112.598 29.7246 88.7742 5.90039 59.4984 5.90039ZM59.4984 107.38C32.8186 107.38 11.1184 85.6802 11.1184 59.0004C11.1184 32.3206 32.8186 10.6204 59.4984 10.6204C86.1782 10.6204 107.878 32.3206 107.878 59.0004C107.878 85.6802 86.1782 107.38 59.4984 107.38ZM85.9422 40.8166C86.8626 41.737 86.8626 43.2356 85.9422 44.156L52.9022 77.196C52.442 77.6444 51.8402 77.8804 51.2384 77.8804C50.6366 77.8804 50.0348 77.6444 49.5746 77.1842L33.0546 60.6642C32.1342 59.7438 32.1342 58.2452 33.0546 57.3248C33.975 56.4044 35.4736 56.4044 36.394 57.3248L51.2384 72.181L82.6146 40.8048C83.535 39.8844 85.0218 39.8844 85.9422 40.8166Z",
    fill: "#39A871"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.d8e96a6d725cbab968e96d3f6b64b433.svg";
export { ForwardRef as ReactComponent };